import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';

import { ActivacionOTCellFotosPending } from '@/erp/operaciones/activaciones/instalaciones/shared/components/tables';
import { EstadoLlamadaComponent } from '@/erp/operaciones/instalaciones/shared/components';
import { EstadoOTNewTableCell } from '@/erp/tecnico/shared/components';
import {
  TABLE_CONSTANTS_COLUMS,
  booleanCellValues,
  cellLineaRazonSocial,
  checkTimePassed,
  emptyCellOneLevel,
  formatCurrency,
  formatDate,
  formatDateWithTime,
  formatDateWithTimeCell,
  formatHour,
} from '@/shared';
import { EstadoComponente, ModalObservacionComponente } from '@/shared/components/ui';
import { OrdenTrabajo } from '@/shared/interfaces';
import EstadoActivacionComponent from '@/erp/operaciones/instalaciones/shared/components/TableCellComponents/EstadoActivacionComponent';
import dayjs from 'dayjs';

export const useColumnsInstalacionesOT = () => {
  ///* columns ==============================
  // base columns -------------
  const columnsOTNewBase01 = useMemo<MRT_ColumnDef<OrdenTrabajo>[]>(
    () => [
      {
        accessorKey: 'razon_social',
        header: 'Nombre',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
        Cell: ({ row }) => cellLineaRazonSocial(row.original?.contrato_data, row.original.prospecto_data?.razon_social!) 
         //`${row.original?.prospecto_data?.razon_social} ${row.original?.contrato_data?.linea != 1 ? `- LINEA ${row.original?.contrato_data?.linea}` : ''}` || 'N/A',
      },
      {
        accessorKey: 'observacion_cliente',
        header: 'Observacion Cliente',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => (
          <ModalObservacionComponente
            observacion_cliente={
              row.original?.observaciones?.observacion_cliente || 'N/A'
            }
          />
        ),
      },
      {
        accessorKey: 'identificacion',
        header: 'identificacion',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.prospecto_data?.identificacion || 'N/A',
      },
      {
        accessorKey: 'numero_contrato',
        header: 'Núm. Contrato',
        size: 240,
        Cell: ({ row }) =>
          row.original?.contrato_data?.numero_referencia || 'N/A',
      },

      {
        accessorKey: 'fecha_instalacion',
        header: 'Hora de instalación',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.fecha_instalacion
            ? formatDate(row.original?.fecha_instalacion)
            : 'N/A',
      },
      {
        accessorKey: 'hora_instalacion',
        header: 'Hora Instalación',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) =>
          row.original?.hora_instalacion
            ? formatHour(row.original?.hora_instalacion)
            : 'N/A',
      },
      {
        accessorKey: 'ciudad_nombre',
        header: 'Ciudad',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => row.original?.ciudad_data?.nombre || 'N/A',
      },
      {
        accessorKey: 'direccion',
        header: 'Dirección Cliente',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => row.original?.agendamiento_data?.direccion || 'N/A',
      },
      {
        accessorKey: 'celular',
        header: 'Celular Cliente',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => emptyCellOneLevel(row, 'celular'),
      },
      {
        accessorKey: 'celular_2',
        header: 'CELULAR 2',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => row.original?.preventa_data?.celular_2 || 'N/A',
      },

      // estado llamada ------------------
      {
        accessorKey: 'estado_llamada',
        header: 'Estado de llamada',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          return row.original?.agendamiento_data?.estado_llamada ? (
            <EstadoLlamadaComponent
              estado={row.original?.agendamiento_data.estado_llamada}
            />
          ) : (
            'N/A'
          );
        },
      },
      {
        accessorKey: 'observacion_llamada',
        header: 'Observación de llamada',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <ModalObservacionComponente
            observacion_cliente={
              row.original?.agendamiento_data?.observaciones?.observacion_llamada || 'N/A'
            }
          />
        ),
      },
      {
        accessorKey: 'fecha_aceptacion',
        header: 'fecha de aceptación',
        size: 300,
        Cell: ({ row }) => row.original?.preventa_data?.fecha_aceptacion ? dayjs(row.original?.preventa_data?.fecha_aceptacion).format("L LT") : "N/A",
      },

      //
      {
        accessorKey: 'coordenadas',
        header: 'COORDENADAS',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.agendamiento_data?.coordenadas || 'N/A',
      },
      {
        accessorKey: 'email',
        header: 'EMAIL',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => row.original?.preventa_data?.email || 'N/A',
      },

      // Persona de referencia ------------------
      {
        accessorKey: 'persona_referencia_nombre',
        header: 'Persona de referencia',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
        Cell: ({ row }) =>
          row.original?.preventa_data?.persona_referencia_nombre || 'N/A',
      },
      {
        accessorKey: 'persona_referencia_parentesco',
        header: 'Parentesco de referencia',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) =>
          row.original?.preventa_data?.persona_referencia_parentesco || 'N/A',
      },
      {
        accessorKey: 'persona_referencia_celular',
        header: 'Celular de referencia',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.preventa_data?.persona_referencia_celular || 'N/A',
      },
    ],
    []
  );

  const columnsOTNewEstadoOnlyOT = useMemo<MRT_ColumnDef<OrdenTrabajo>[]>(
    () => [
      {
        accessorKey: 'estado_orden_trabajo_exclude',
        header: 'Estado Orden Trabajo',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.estado_orden_trabajo ? (
            <EstadoOTNewTableCell
              codigo={row.original.estado_orden_trabajo}
              nombre={row.original.estado_orden_trabajo || 'N/A'}
            />
          ) : (
            'N/A'
          ),
      },
    ],
    []
  );
  const columnsOTMotivoRechazoOnly = useMemo<MRT_ColumnDef<OrdenTrabajo>[]>(
    () => [
      {
        accessorKey: 'motivo_rechazo',
        header: 'Motivo Rechazo',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => (
          <ModalObservacionComponente
            observacion_cliente={row.original?.motivo_rechazo || 'N/A'}
          />
        ),
      },
      {
        accessorKey: 'observacion_rechazo_tecnico',
        header: 'Observación Motivo Rechazo',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => (
          <ModalObservacionComponente
            observacion_cliente={
              row.original?.observaciones?.observacion_rechazo_tecnico || 'N/A'
            }
          />
        ),
      },
    ],
    []
  );

  const columnsOTNewBase02 = useMemo<MRT_ColumnDef<OrdenTrabajo>[]>(
    () => [
      ///* fk ========================================
      // // plan ------------------
      {
        accessorKey: 'tipo_plan',
        header: 'Tipo Plan',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => {
          return row.original?.preventa_data?.tipo_plan || 'N/A';
        },
      },
      {
        accessorKey: 'tipo_servicio',
        header: 'Tipo de servicio',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => {
          return row.original?.preventa_data?.tipo_servicio || 'N/A';
        },
      },
      {
        accessorKey: 'plan',
        header: 'Plan de internet',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => {
          return row.original?.plan_data?.nombre || 'N/A';
        },
      },
      {
        accessorKey: 'velocidad_internet',
        header: 'Velocidad de internet',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => {
          return row.original?.preventa_data?.velocidad
            ? `${row.original?.preventa_data?.velocidad} ${row.original?.plan_data?.unidad}`
            : 'N/A';
        },
      },
      {
        accessorKey: 'valor_plan',
        header: 'Valor del plan',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => {
          return row.original?.preventa_data?.valor_plan
            ? formatCurrency(row.original?.preventa_data?.valor_plan)
            : formatCurrency(0);
        },
      },

      // valor_instalacion ------------------
      {
        accessorKey: 'valor_instalacion',
        header: 'Valor Instalación',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => {
          return row.original?.preventa_data?.valor_instalacion
            ? formatCurrency(row.original?.preventa_data?.valor_instalacion)
            : formatCurrency(0);
        },
      },

      // flota & nap ------------------
      {
        accessorKey: 'flota_nombre',
        header: 'FLOTA',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => row.original?.flota_data?.nombre || 'N/A',
      },
      {
        accessorKey: 'nap_data_nombre',
        header: 'NAP',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => row.original?.nap_data_nombre || 'N/A',
      },
      {
        accessorKey: 'distancia',
        header: 'DISTANCIA A LA NAP',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => emptyCellOneLevel(row, 'distancia'),
      },
    ],
    []
  );

  const columsInstalacionTrazabilidad = useMemo<MRT_ColumnDef<OrdenTrabajo>[]>(
    () => [
      ///* trazabilidad ------------------

      {
        accessorKey: 'fecha_creacion',
        header: 'Fecha Creación',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        enableColumnFilter: true,
        filterVariant: 'date',
        enableSorting: false,
        Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_creacion'),
      },
      {
        accessorKey: 'fecha_modificacion',
        header: 'Fecha Modificación',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        enableColumnFilter: true,
        filterVariant: 'date',
        enableSorting: false,
        Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_modificacion'),
      },
    ],
    []
  );

  const columnsOTActivacionData = useMemo<MRT_ColumnDef<OrdenTrabajo>[]>(
    () => [
      {
        accessorKey: 'ipv_4_actual',
        header: 'Dirección IP',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => emptyCellOneLevel(row, 'ipv_4_actual'),
      },
      {
        accessorKey: 'pppoe',
        header: 'PPPoE',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
        Cell: ({ row }) => emptyCellOneLevel(row, 'pppoe'),
      },
      {
        accessorKey: 'pppassword',
        header: 'PPPassword',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
        Cell: ({ row }) => emptyCellOneLevel(row, 'pppassword'),
      },

      {
        accessorKey: 'es_router_ac',
        header: 'Tiene Router AC',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => booleanCellValues(row, 'es_router_ac'),
      },
      {
        accessorKey: 'serie_ont',
        header: 'Serie ONT',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => emptyCellOneLevel(row, 'serie_ont'),
      },
    ],
    []
  );

  const columnsObserservPreventaColums = useMemo<MRT_ColumnDef<OrdenTrabajo>[]>(
    () => [
      {
        accessorKey: 'observaciones',
        header: 'Observación 1 - Vendedor',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => (
          <ModalObservacionComponente
            observacion_cliente={
              row.original?.preventa_data?.observaciones.observacion_1 || 'N/A'
            }
          />
        ),
      },
      {
        accessorKey: 'observaciones_2',
        header: 'Observación 2 - Vendedor',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => (
          <ModalObservacionComponente
            observacion_cliente={
              row.original?.preventa_data?.observaciones.observacion_2 || 'N/A'
            }
          />
        ),
      },
    ],
    []
  );

  const columsObservacionActivacionOnlyColum = useMemo<
    MRT_ColumnDef<OrdenTrabajo>[]
  >(
    () => [
      {
        accessorKey: 'observacion_activacion',
        header: 'Observación Activación',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => (
          <ModalObservacionComponente
            observacion_cliente={
              row.original?.observaciones?.observacion_activacion || 'N/A'
            }
          />
        ),
      },
    ],
    []
  );
  const columsPuertoOnlyActivacion = useMemo<MRT_ColumnDef<OrdenTrabajo>[]>(
    () => [
      {
        accessorKey: 'puerto',
        header: 'Puerto',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => emptyCellOneLevel(row, 'puerto'),
      },
    ],
    []
  );
  const columnsHoraInitFinActivacion = useMemo<MRT_ColumnDef<OrdenTrabajo>[]>(
    () => [
      {
        accessorKey: 'hora_inicio',
        header: 'Hora Inicio Instalación',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.hora_inicio
            ? formatHour(row.original?.hora_inicio)
            : 'N/A',
      },
      {
        accessorKey: 'hora_fin',
        header: 'Hora Fin Instalación',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.hora_fin ? formatHour(row.original?.hora_fin) : 'N/A',
      },
    ],
    []
  );
  const columnsFotoEntrada = useMemo<MRT_ColumnDef<OrdenTrabajo>[]>(
    () => [
      {
        accessorKey: 'urls_fotos_entrada',
        header: 'Fotos Entrada',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => (
          <ActivacionOTCellFotosPending
            ordenTrabajo={row.original}
            isReviewingFotosEntrada
          />
        ),
      },
    ],
    []
  );
  const columnsFotoSalida = useMemo<MRT_ColumnDef<OrdenTrabajo>[]>(
    () => [
      {
        accessorKey: 'urls_fotos_salida',
        header: 'Fotos Salida',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => (
          <ActivacionOTCellFotosPending
            ordenTrabajo={row.original}
            isReviewingFotosSalida
          />
        ),
      },
    ],
    []
  );

  // tables ------------------
  const instalacionesAsignadasTecnicoColumns = useMemo<
    MRT_ColumnDef<OrdenTrabajo>[]
  >(
    () => [
      {
        accessorKey: 'fecha_instalacion',
        header: 'Fecha de Instalación',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => row.original?.fecha_instalacion || 'N/A',
      },
      // {
      //   accessorKey: 'hora_instalacion',
      //   header: 'Hora Instalación',
      //   size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
      //   Cell: ({ row }) =>
      //     row.original?.hora_instalacion
      //       ? formatHour(row.original?.hora_instalacion)
      //       : 'N/A',
      // },
      {
        accessorKey: 'razon_social',
        header: 'Cliente',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
        Cell: ({ row }) => cellLineaRazonSocial(row.original?.contrato_data, row.original.prospecto_data?.razon_social!) 
         //`${row.original?.prospecto_data?.razon_social} ${row.original?.contrato_data?.linea != 1 ? `- LINEA ${row.original?.contrato_data?.linea}` : ''}` || 'N/A',
      },
      {
        accessorKey: 'vendedor_nombre',
        header: 'Vendedor',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
        Cell: ({ row }) => row.original?.vendedor_data?.razon_social || 'N/A',
         //`${row.original?.prospecto_data?.razon_social} ${row.original?.contrato_data?.linea != 1 ? `- LINEA ${row.original?.contrato_data?.linea}` : ''}` || 'N/A',
      },
      {
        accessorKey: 'canal_venta',
        header: 'Canal de Venta',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => row.original?.prospecto_data?.canal_venta_create || 'N/A',
      },
      {
        accessorKey: 'sector_nombre',
        header: 'Sector',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => `${row.original?.sector_data?.nombre} ${row.original?.sector_data?.parroquia?(" / "+row.original?.sector_data?.parroquia):""}` || 'N/A',
      },
      {
        accessorKey: 'ciudad_nombre',
        header: 'Ciudad',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => row.original?.ciudad_data?.nombre || 'N/A',
      },
      {
        accessorKey: 'zona_nombre',
        header: 'Zona',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => row.original?.zona_data?.nombre || 'N/A',
      },
      {
        accessorKey: 'celular',
        header: 'Celular Cliente',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => emptyCellOneLevel(row, 'celular'),
      },

      {
        accessorKey: 'persona_referencia_celular',
        header: 'Celular de referencia',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.preventa_data?.persona_referencia_celular || 'N/A',
      },
      {
        accessorKey: 'plan_data.nombre',
        header: 'Plan Contrato',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.plan_data?.nombre || 'N/A',
      },
      {
        accessorKey: 'tipo_orden_trabajo',
        header: 'Tipo Orden de Trabajo',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) =>
          row.original?.tipo_orden_trabajo || 'N/A',
      },
      ...columnsObserservPreventaColums,
      {
        accessorKey: 'observaciones.observacion_llamada',
        header: 'Observación PyL',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) =>
          row.original?.observaciones?.observacion_llamada || 'N/A',
      },
      // ...columnsOTNewBase01,
      ...columnsOTNewBase02,
      ...columnsOTNewEstadoOnlyOT,
      ...columnsOTActivacionData,
      {
        accessorKey: 'es_router_ac',
        header: 'Tiene Router AC',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => booleanCellValues(row, 'es_router_ac'),
      },
      {
        accessorKey: 'serie_ont',
        header: 'Serie ONT',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => emptyCellOneLevel(row, 'serie_ont'),
      },
      // ...columnsObserservPreventaColums,
      ...columsInstalacionTrazabilidad,
    ],
    []
  );

  const instalacionesActivacionRealizadaColumns = useMemo<
    MRT_ColumnDef<OrdenTrabajo>[]
  >(
    () => [
      ...columnsOTNewBase01,
      ...columnsOTNewBase02,
      ...columnsOTNewEstadoOnlyOT,
      ...columsPuertoOnlyActivacion,
      ...columnsOTActivacionData,
      ...columnsHoraInitFinActivacion,
      ...columnsObserservPreventaColums,
      ...columsObservacionActivacionOnlyColum,
      ...columsInstalacionTrazabilidad,
    ],
    []
  );

  const pylInstallPrerechazadaPendingColumns = useMemo<
    MRT_ColumnDef<OrdenTrabajo>[]
  >(
    () => [
      ...columnsOTNewBase01,
      ...columnsOTNewEstadoOnlyOT,
      ...columnsOTMotivoRechazoOnly,
      ...columnsOTNewBase02,
      ...columnsOTActivacionData,
      ...columnsObserservPreventaColums,
      ...columsInstalacionTrazabilidad,
    ],
    []
  );

  const instalacionesRealizadasColumns = useMemo<MRT_ColumnDef<OrdenTrabajo>[]>(
    () => [
      {
        accessorKey: 'hora_inicio',
        header: 'hora inicio',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.hora_inicio
            ? formatHour(row.original?.hora_inicio)
            : 'N/A',
      },
      {
        accessorKey: 'hora_fin',
        header: 'hora fin',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.hora_fin
            ? formatHour(row.original?.hora_fin)
            : 'N/A',
      },
      {
        accessorKey: 'fecha_instalacion',
        header: 'Fecha de instalación',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.fecha_instalacion
            ? formatDate(row.original?.fecha_instalacion)
            : 'N/A',
      },
      {
        accessorKey: 'hora_instalacion',
        header: 'Hora Instalación',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => (
          row.original?.hora_instalacion
            ?
            <EstadoComponente
              backgroundColor={checkTimePassed(formatDate(row.original?.fecha_instalacion!), row.original?.hora_instalacion, (row.original.hora_inicio||""))}
              texto={formatHour(row.original?.hora_instalacion) || ''} />
            : 'N/A'
        ),
      },
      ...columnsOTNewBase01,
      ...columnsOTNewBase02,
      ...columnsObserservPreventaColums,
      ...columsInstalacionTrazabilidad,
    ],
    []
  );

  const instalacionesAsignadasColumns = useMemo<MRT_ColumnDef<OrdenTrabajo>[]>(
    () => [
      {
        accessorKey: 'hora_inicio',
        header: 'hora inicio',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.hora_inicio
            ? formatHour(row.original?.hora_inicio)
            : 'N/A',
      },
      {
        accessorKey: 'hora_fin',
        header: 'hora fin',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.hora_fin
            ? formatHour(row.original?.hora_fin)
            : 'N/A',
      },
      {
        accessorKey: 'estado_activacion',
        header: 'estado de activación',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => {
          return row.original?.estado_activacion ? (
            <EstadoActivacionComponent
              estado={row.original?.estado_activacion.toUpperCase()}
            />
          ) : (
            'N/A'
          );
        },
        // row.original?.estado_activacion
        //   ? row.original?.estado_activacion
        //   : 'N/A',
      },
      {
        accessorKey: 'estado_orden_trabajo',
        header: 'Estado Orden Trabajo',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.estado_orden_trabajo ? (
            <EstadoOTNewTableCell
              codigo={row.original.estado_orden_trabajo}
              nombre={row.original.estado_orden_trabajo || 'N/A'}
            />
          ) : (
            'N/A'
          ),
      },
      {
        accessorKey: 'fecha_instalacion',
        header: 'Fecha de instalación',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.fecha_instalacion
            ? formatDate(row.original?.fecha_instalacion)
            : 'N/A',
      },
      {
        accessorKey: 'hora_instalacion',
        header: 'Hora Instalación',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => (
          row.original?.hora_instalacion
            ?
            <EstadoComponente
              backgroundColor={checkTimePassed(formatDate(row.original?.fecha_instalacion!), row.original?.hora_instalacion, (row.original.hora_inicio || ""))}
              texto={formatHour(row.original?.hora_instalacion) || ''} />
            : 'N/A'
        ),
      },
      ...columnsOTNewBase01,
      ...columnsOTNewBase02,
      ...columnsObserservPreventaColums,
      ...columsInstalacionTrazabilidad,
    ],
    []
  );

  const instalacionesAsignadasRecoordinadasTecnicoColumns = useMemo<
    MRT_ColumnDef<OrdenTrabajo>[]
  >(
    () => [
      ...columnsOTNewBase01,
      ...columnsOTNewBase02,
      ...columnsOTNewEstadoOnlyOT,
      ...columnsOTActivacionData,

      ...columnsObserservPreventaColums,
      ...columsInstalacionTrazabilidad,
    ],
    []
  );

  const instalacionesPendienteActualizarColumns = useMemo<
    MRT_ColumnDef<OrdenTrabajo>[]
  >(
    () => [
      ...columnsOTNewBase01,
      ...columnsOTNewBase02,
      ...columnsOTNewEstadoOnlyOT,
      ...columnsOTActivacionData,

      ...columnsObserservPreventaColums,
      ...columsInstalacionTrazabilidad,
    ],
    []
  );


  const instalacionesPendienteActualizacionColumns = useMemo<MRT_ColumnDef<OrdenTrabajo>[]>(
    () => [
      {
        accessorKey: 'observacion_actualizacion_tecnico',
        header: 'Observación Actualización Técnico',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => (
          <ModalObservacionComponente
            observacion_cliente={
              row.original?.observaciones?.observacion_actualizacion_tecnico || 'N/A'
            }
          />
        ),
      },
      ...instalacionesAsignadasTecnicoColumns,
    ],
    []
  );





  const columnsPreRechazoTecnicoATS = useMemo<MRT_ColumnDef<OrdenTrabajo>[]>(
    () => [
      {
        accessorKey: 'razon_social',
        header: 'Nombre',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
        Cell: ({ row }) => cellLineaRazonSocial(row.original?.contrato_data, row.original.prospecto_data?.razon_social!) 
         //`${row.original?.prospecto_data?.razon_social} ${row.original?.contrato_data?.linea != 1 ? `- LINEA ${row.original?.contrato_data?.linea}` : ''}` || 'N/A',
      },
      {
        accessorKey: 'identificacion',
        header: 'identificacion',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.prospecto_data?.identificacion || 'N/A',
      },
      {
        accessorKey: 'coordenadas',
        header: 'Coordenadas',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.agendamiento_data?.coordenadas || 'N/A',
      },
      {
        accessorKey: 'fecha_instalacion',
        header: 'Hora de instalación',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.fecha_instalacion
            ? formatDate(row.original?.fecha_instalacion)
            : 'N/A',
      },
      {
        accessorKey: 'hora_instalacion',
        header: 'Hora Instalación',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) =>
          row.original?.hora_instalacion
            ? formatHour(row.original?.hora_instalacion)
            : 'N/A',
      },
      {
        accessorKey: 'fecha_creacion',
        header: 'Fecha Creación',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.fecha_creacion
            ? formatDateWithTime(row.original?.fecha_creacion)
            : 'N/A',
      },
      {
        accessorKey: 'fecha_modificacion',
        header: 'Fecha Modificación',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.fecha_modificacion
            ? formatDateWithTime(row.original?.fecha_modificacion)
            : 'N/A',
      },
    ],
    []
  );



  return {
    instalacionesAsignadasTecnicoColumns,
    instalacionesActivacionRealizadaColumns,

    instalacionesAsignadasRecoordinadasTecnicoColumns,
    instalacionesPendienteActualizarColumns,

    pylInstallPrerechazadaPendingColumns,
    instalacionesRealizadasColumns,

    instalacionesAsignadasColumns,
    instalacionesPendienteActualizacionColumns,

    //temp
    columnsFotoEntrada,
    columnsFotoSalida,


    //PLANTA EXTERNA
    columnsPreRechazoTecnicoATS,
  
  };
};
